export interface IBaseNode {
    name: string;
    description: string;
    readonly nodeType: NodeType;

    asc: boolean;
    orderBy: string;
    enabled: boolean;
}

export enum NodeType {
    SimpleNode,
    NearbyAssetNode,
    Document,
    Record,
    Layer,
    Table,
    Category
}
